module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "contents",
      "title": "Table of Contents"
    }
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#aintro"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#aintro"
    }
  }, [_vm._v("On the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ach1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ach1"
    }
  }, [_vm._v("The Work Enslaves Us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ach2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ach2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SITRATERCO: Women’s Power Is Union Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ach3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ach3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honduras: A Free Space")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ach4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ach4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Latin America: The Big Challenge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ach5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ach5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ach6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER SIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ach6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Global Allies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conclusion#acon",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONCLUSION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conclusion#acon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Kind of Labor Movement")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "notes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Notes#anotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#aindex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "author"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Author#aauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f62c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 69
// module chunks = 0